import MotorEventosOrdinariosService from "./motor-eventos-ordinarios-service"
import MotorParametrosService from "./motor-parametros-service"
import MotorDataAniversarioService from "./motor-data-aniversario-service"
import MotorService from "./motor-service"

export class MotorDuplicarEventosService {

    constructor() {
        this.motorService = new MotorService()
        this.parametrosService = new MotorParametrosService()
        this.dataAniversarioService = new MotorDataAniversarioService()
        this.eventosService = new MotorEventosOrdinariosService()
    }

    async duplicaCadastroEventos(novoCetip, novaVersao, cadastroId, cadastroDestinoId) {
        const results = await Promise.allSettled([
            this.motorService.getCadastro(cadastroDestinoId),

            // temporario
            this.parametrosService.getCadastroTemporarioParametros(cadastroId),
            this.eventosService.getTemporarioEventosOrdinarios(cadastroId),
            this.dataAniversarioService.getTemporarioDataAniversario(cadastroId),

            // producao
            this.parametrosService.getCadastroParametros(cadastroId),
            this.eventosService.getEventosOrdinarios(cadastroId),
            this.dataAniversarioService.getDataAniversario(cadastroId)
        ])

        const [
            caracteristicaRes,

            parametrosTempRes,
            eventosOrdinariosTempRes,
            dataAniversarioTempRes,

            parametrosProdRes,
            eventosOrdinariosProdRes,
            dataAniversarioProdRes
        ] = results


        const getValue = (res) => res?.status === 'fulfilled' ? res.value : null
        const caracteristica = getValue(caracteristicaRes)

        const parametros = getValue(parametrosProdRes) ?? getValue(parametrosTempRes)
        const eventosOrdinarios = getValue(eventosOrdinariosProdRes) ?? getValue(eventosOrdinariosTempRes)
        const dataAniversario = getValue(dataAniversarioProdRes) ?? getValue(dataAniversarioTempRes)

        const novoParametros = {
            ...this.getBodyOrNull(parametros),
            CETIP: novoCetip,
            VersaoDocumento: novaVersao,
            ID: null
        }

        return {
            'CETIP': novoCetip,
            'VersaoDocumento': novaVersao,
            'caracteristica': this.getBodyOrNull(caracteristica),
            'parametros': novoParametros,
            'eventosOrdinarios': this.getBodyOrNull(eventosOrdinarios),
            'dataAniversario': this.getBodyOrNull(dataAniversario)
        }
    }

    getBodyOrNull = (result) => result?.body ?? null
}